<!-- Search Criteria -->
<div class="bpaas-content">
  <form [formGroup]="formGroup">
    <p-panel header="{{'label.search' | translate }}" [toggleable]="true" [collapsed]="panelCollapsed"
      expandIcon="pi pi-angle-double-up" collapseIcon="pi pi-angle-double-down">
      <div class="card" #contentElement pBPaaSFocusTrap>
        <div class="grid p-fluid">
          <!-- OU -->
          <div class="col-12 md:col-3 lg:col-3">
            <label [for]="parseToId('ouId')" class="bpaas-required">{{ 'field.ou' | translate }}</label>
            <p-autoComplete *ngIf="langChangeVisible" [suggestions]="ouSuggestions" [forceSelection]="true"
              [minLength]="2" [delay]="300" [showClear]="true" [showEmptyMessage]="true"
              emptyMessage="{{ 'table.no-records-found' | translate }}" (completeMethod)="searchOuSuggestions($event)"
              (onClear)="autoCompleteCleared('autoCompleteCode')" (onFocus)="autoCompleteFocus($event)"
              (onBlur)="autoCompleteBlur($event)" (onKeyUp)="autoCompleteKeyUp($event)"
              (onSelect)="autoCompleteCompleted('autoCompleteCode')" dataKey="value" appendTo="body"
              formControlName="ouId" [inputId]="parseToId('ouId')" field="label">
            </p-autoComplete>
            <div *ngIf="formControlInvalid('ouId')">
              <small class="p-error" *ngIf="formControl('ouId').errors?.['required']">
                {{ 'message.validation.required' | translate }}
              </small>
            </div>
          </div>
          <!-- Cust -->
          <div class="col-12 md:col-3 lg:col-3">
            <label [for]="parseToId('cust')">{{ 'field.cust' | translate }}</label>
            <p-autoComplete *ngIf="langChangeVisible" [suggestions]="custSuggestions" [forceSelection]="true"
              [minLength]="2" [delay]="300" [showClear]="true" [showEmptyMessage]="true"
              emptyMessage="{{ 'table.no-records-found' | translate }}" (completeMethod)="searchCustSuggestions($event)"
              (onClear)="autoCompleteCleared('autoCompleteCode')" (onFocus)="autoCompleteFocus($event)"
              (onBlur)="autoCompleteBlur($event)" (onKeyUp)="autoCompleteKeyUp($event)"
              (onSelect)="autoCompleteCompleted('autoCompleteCode')" dataKey="value" appendTo="body"
              formControlName="cust" [inputId]="parseToId('cust')" field="label">
            </p-autoComplete>
          </div>
          <!-- Currency -->
          <div class="col-12 md:col-3 lg:col-3">
            <label [for]="parseToId('currency')">Currency</label>
            <p-dropdown [options]="currencyOptions"
              formControlName="currency"
              optionLabel="label"
              optionValue="value"
              [id]="parseToId('currency')"
              [showClear]="true"
              [filter]="true"
              filterBy="label"
              placeholder="Select currency"
              appendTo="body">
            </p-dropdown>
          </div>
        </div>
        <div class="grid p-fluid">
          <!-- Item Number (required) -->
          <div class="col-12 md:col-3 lg:col-3">
            <label [for]="parseToId('itemNumber')" class="bpaas-required">{{ 'field.item-number' | translate }}</label>
            <p-autoComplete *ngIf="langChangeVisible" [suggestions]="itemSuggestions" [forceSelection]="true"
              [minLength]="2" [delay]="300" [showClear]="true" [showEmptyMessage]="true"
              emptyMessage="{{ 'table.no-records-found' | translate }}" (completeMethod)="searchItemSuggestions($event)"
              (onClear)="onItemClear()" (onFocus)="autoCompleteFocus($event)" (onBlur)="autoCompleteBlur($event)"
              (onKeyUp)="autoCompleteKeyUp($event)" (onSelect)="onItemSelect($event)" dataKey="value" appendTo="body"
              formControlName="itemNumber" [inputId]="parseToId('itemNumber')" field="label">
            </p-autoComplete>
            <div *ngIf="formControlInvalid('itemNumber')">
              <small class="p-error" *ngIf="formControl('itemNumber').errors?.['required']">
                {{ 'message.validation.required' | translate }}
              </small>
            </div>
          </div>
          <!-- Item Desc (readonly) -->
          <div class="col-12 md:col-6 lg:col-6">
            <label [for]="parseToId('itemDesc')">{{ 'field.item-desc' | translate }}</label>
            <input type="text" pInputText formControlName="itemDesc" [id]="parseToId('itemDesc')" readonly />
          </div>
        </div>
        <!-- Buttons -->
        <div class="grid p-fluid justify-content-end bpaas-button-row">
          <div class="col-12 md:col-3 lg:col-2">
            <button type="button" pButton label="{{ 'button.reset' | translate }}" class="p-button-outlined mr-2"
              (click)="searchReset();onItemClear();" [id]="parseToId('btnReset')"></button>
          </div>
          <div class="col-12 md:col-3 lg:col-2">
            <button type="button" pButton label="{{ 'button.query' | translate }}" (click)="query()"
              [id]="parseToId('btnQuery')"></button>
          </div>
        </div>
      </div>
    </p-panel>
  </form>
</div>

<!-- Result Table -->
<div class="bpaas-content" [style.--uc-frozen-width]="frozenWidth">
  <p-panel header="2Year Detail">
    <!-- QueryId -->
    <span *ngIf="queryId">{{ 'field.query-id' | translate }} : {{queryId}}</span>
    <p-table *ngIf="tableVisible" #tableComponent [value]="detailDatas" styleClass="p-datatable-gridlines p-datatable-sm p-datatable-striped"
      [selectionMode]="tableSelectionMode" [(selection)]="rowSelectedDatas" [dataKey]="rowDataKeyName"
      [paginator]="true" [rows]="10" [showCurrentPageReport]="true"
      currentPageReportTemplate="{{ 'table.paginator' | translate: {'first': '{first}', 'last': '{last}', 'totalRecords': '{totalRecords}' } }}"
      [rowsPerPageOptions]="[10, 20, 50]" [paginatorDropdownAppendTo]="'body'" scrollHeight="75vh" [scrollable]="true"
      [resizableColumns]="true" columnResizeMode="expand"
      [detailInViewStatus]="detailInViewStatus()" (onStateSave)="onDetailTableStateSave($event)"
      (onFilter)="onDetailTableFilter($event)" (onColResize)="onColResize($event)"
      (onPage)="updateFrozenWidthDeferred()" (onSort)="updateFrozenWidthDeferred()">

      <!-- Two-row header: row 1 = group titles, row 2 = column names -->
      <ng-template pTemplate="header">
        <!-- Row 1: Group title row (merged frozen cell + group headers) -->
        <tr>
          <!-- Desktop: single merged frozen cell spanning all frozen columns -->
          <th *ngIf="effectiveFrozenCount > 0"
              pFrozenColumn class="uc-group-empty"
              [attr.colspan]="effectiveFrozenCount"></th>
          <!-- Mobile: single merged cell spanning all frozen-equivalent columns -->
          <th *ngIf="effectiveFrozenCount === 0"
              class="uc-group-empty"
              [attr.colspan]="frozenCount"></th>
          <!-- Previous OD group header -->
          <th [attr.colspan]="prevOdColumns.length" class="uc-group-header">Previous Order</th>
          <!-- Previous Ship group header -->
          <th [attr.colspan]="prevShipColumns.length" class="uc-group-header">Previous Ship</th>
        </tr>

        <!-- Row 2: Column name row -->
        <tr>
          <!-- Desktop: frozen column headers -->
          <th *ngFor="let col of tableColumns.slice(0, effectiveFrozenCount)"
              pFrozenColumn
              [pSortableColumn]="col.sortable ? col.field : ''"
              [pSortableColumnDisabled]="!col.sortable"
              [style]="col.minWidth ? 'min-width:' + col.minWidth + 'px' : ''"
              pResizableColumn>
            <label>{{ col.header }}</label>
            <p-sortIcon *ngIf="col.sortable" [field]="col.field"></p-sortIcon>
          </th>
          <!-- Mobile: non-frozen column headers for frozen cols -->
          <ng-container *ngIf="effectiveFrozenCount === 0">
            <th *ngFor="let col of tableColumns.slice(0, frozenCount)"
                [pSortableColumn]="col.sortable ? col.field : ''"
                [pSortableColumnDisabled]="!col.sortable"
                [style]="col.minWidth ? 'min-width:' + col.minWidth + 'px' : ''"
                pResizableColumn>
              <label>{{ col.header }}</label>
              <p-sortIcon *ngIf="col.sortable" [field]="col.field"></p-sortIcon>
            </th>
          </ng-container>
          <!-- Scrollable column headers (Previous OD + Previous Ship) -->
          <th *ngFor="let col of scrollableColumns"
              [pSortableColumn]="col.sortable ? col.field : ''"
              [pSortableColumnDisabled]="!col.sortable"
              pResizableColumn>
            <label>{{ col.header }}</label>
            <p-sortIcon *ngIf="col.sortable" [field]="col.field"></p-sortIcon>
          </th>
        </tr>
      </ng-template>

      <!-- Table Body -->
      <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex">
        <tr [id]="parseToId('rowData-' + rowIndex)">
          <!-- Frozen columns -->
          <td *ngFor="let col of tableColumns.slice(0, effectiveFrozenCount)"
              pFrozenColumn
              [style]="col.minWidth ? 'min-width:' + col.minWidth + 'px' : ''">
            {{ rowData[col.field] }}
          </td>
          <!-- Non-frozen section when on mobile -->
          <ng-container *ngIf="effectiveFrozenCount === 0">
            <td *ngFor="let col of tableColumns.slice(0, frozenCount)"
                [style]="col.minWidth ? 'min-width:' + col.minWidth + 'px' : ''">
              {{ rowData[col.field] }}
            </td>
          </ng-container>
          <!-- Scrollable columns -->
          <td *ngFor="let col of scrollableColumns"
              [class.bpaas-align-right]="col.numberField || col.alignRight">
            <ng-container *ngIf="col.numberField">
              {{ (rowData[col.field] ?? 0) | dynamicDecimal }}
            </ng-container>
            <ng-container *ngIf="!col.numberField">
              {{ rowData[col.field] }}
            </ng-container>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td [colSpan]="tableColumns.length">
            {{ 'table.no-records-found' | translate }}
          </td>
        </tr>
      </ng-template>
    </p-table>
  </p-panel>
</div>
